import { backofficeRolesWithoutAcExpo } from "@ac-expo/api-types";
import { getPasswordMessage, MINIMUM_PASSWORD_LENGTH } from "@ac-expo/utils";
import { sirenOrSiretSchema, vatSchema, validateVatWithSiren } from "../utils";
import { z } from "zod";

export const signupSchema = z
  .object({
    roles: z
      .array(z.enum(backofficeRolesWithoutAcExpo))
      .min(1, "Veuillez choisir au moins un profil")
      .max(4),
    siret: sirenOrSiretSchema.optional(),
    vat: vatSchema.optional(),
    businessName: z
      .string()
      .max(
        128,
        "Veuillez entrer un nom d'entreprise contenant moins de 128 caractères"
      )
      .optional(),
    country: z.string().min(1),
    firstName: z
      .string()
      .min(2, "Veuillez entrer un prénom valide")
      .max(64, "Veuillez entrer un prénom valide"),
    lastName: z
      .string()
      .min(2, "Veuillez entrer un nom valide")
      .max(64, "Veuillez entrer un nom valide"),
    email: z.string().email(""),
    password: z.string().superRefine((val, ctx) => {
      if (
        val.length < MINIMUM_PASSWORD_LENGTH ||
        !/[a-z]/.test(val) ||
        !/[A-Z]/.test(val) ||
        !/[ !"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/.test(val) ||
        !/[0-9]/.test(val)
      ) {
        return ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: getPasswordMessage(val),
        });
      }
    }),
    acceptedTerms: z
      .boolean()
      .refine(
        (val) => val,
        "Veuillez accepter les conditions d'utilisation et notre politique de confidentialité"
      ),
  })
  .superRefine((val, ctx) => {
    validateVatWithSiren(ctx, val.vat, val.siret);
  });

export const defaultSignupValues = {
  roles: [],
  siret: "",
  vat: "",
  country: "",
  businessName: "",
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  acceptedTerms: false,
};

export type SignupForm = z.infer<typeof signupSchema>;
